<template>
    <div class="field">
        <free-input v-if="inputType == 'FreeInputType'" :type="attributeType" :types="attributeTypes" :label="label" />
        <text-input v-else-if="inputType == 'TextInputType'" :type="attributeType" :types="attributeTypes" :label="label" :placeholder="placeholder" :suffix="suffix" />
        <date-input v-else-if="inputType == 'DateInputType'" :label="label" />
        <dropdown-input v-else-if="inputType == 'DropdownType'" :label="label" :type="attributeType" :types="attributeTypes" :placeholder="placeholder" :attributeOptions="options" />
        <selection-input v-else-if="inputType == 'SelectionType'" :label="label" :type="attributeType" :types="attributeTypes" :attributeOptions="options" />
        <duration-input-type v-else-if="inputType == 'DurationType'" :label="label" />
    </div>
</template>

<script>
import FreeInput from './FreeInput.vue';
import TextInput from './TextInput.vue';
import DateInput from './DateInput.vue';
import DropdownInput from './DropdownInput.vue';
import SelectionInput from './SelectionInput.vue';
import DurationInputType from './DurationInputType.vue';
import { AttributeInputTypes } from '../../enums';
import { getAttributeInputType } from '@/helpers/enum-helpers';

export default {
    name: 'DisplayType',
    components: { FreeInput, TextInput, DateInput, DropdownInput, SelectionInput, DurationInputType },
    props: {
        label: {
            type: String,
        },
        placeholder: {
            type: String,
        },
        type: {
            type: Number,
        },
        suffix: {
            type: String,
        },
        options: {
            type: Array,
        },
    },
    data() {
        return {
            attributeType: null,
            attributeTypes: AttributeInputTypes,
            inputType: null,
        };
    },
    created() {
        this.attributeType = getAttributeInputType(this.type);
        switch (this.attributeType) {
            case this.attributeTypes.HEADING:
            case this.attributeTypes.SUB_HEADING:
            case this.attributeTypes.STATIC_TEXT:
                this.inputType = 'FreeInputType';
                break;

            case this.attributeTypes.INPUT_TEXT:
            case this.attributeTypes.NUMBER:
            case this.attributeTypes.LONG_INPUT_TEXT:
                this.inputType = 'TextInputType';
                break;

            case this.attributeTypes.DATE:
                this.inputType = 'DateInputType';
                break;

            case this.attributeTypes.DROP_DOWN:
            case this.attributeTypes.MULTI_DROP_DOWN:
                this.inputType = 'DropdownType';
                break;

            case this.attributeTypes.RADIO:
            case this.attributeTypes.CHECKBOX:
                this.inputType = 'SelectionType';
                break;

            case this.attributeTypes.DURATION:
                this.inputType = 'DurationType';
                break;

            default:
                break;
        }
    },
};
</script>
